module.exports = __webpack_public_path__ + "images/emoji/monorail.212bb6923f44975dffe8.png";